import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right-2TJ8Q",
  "use": "chevron-right-2TJ8Q-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"chevron-right-2TJ8Q\"><path d=\"M9 18l6-6-6-6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol